import { IRegistryLayoutStore } from "../models/RegistryLayoutStore";
import { useRegistryLayoutStore } from "../useRegistryLayoutStore";

export const useSelectIsPaneOpen = (): IRegistryLayoutStore["isPaneOpen"] => {
  const { isPaneOpen } = useRegistryLayoutStore();

  return isPaneOpen;
};
